import React, { useState } from "react";

import {
    Popover,
    TextField,
    Typography
} from '@mui/material';

import pt from 'date-fns/locale/pt';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Calendar } from 'react-date-range';
import { format } from "date-fns";

const classes = {
    labelInput: {
        color: '#333333',
        fontWeight: 'bold',
        paddingLeft: 2,
        fontSize: 14,
        marginBottom: '0.5rem'
    },
    inputText: {
        backgroundColor: 'white'
    }
}

/* Seleção de uma única data, seguindo o mesmo padrão do componente SelectDateRange */
export default function SelectDate({ date, setDate, title, placeholder = 'dd/mm/aaaa', textFieldProps, minDate = new Date(2021, 0), maxDate }) {

    const [dateTemp, setDateTemp] = useState(date ?? new Date());

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setDateTemp(date ?? new Date());
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    /* Ao escolher um dia no calendário, já aplica a data e fecha o popover */
    function handleSelect(item) {
        setDateTemp(item);
        setDate(item);
        handleClose();
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    function popOverSelectDate() {
        return (
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}>
                <Calendar
                    locale={pt}
                    date={dateTemp}
                    onChange={handleSelect}
                    minDate={minDate}
                    maxDate={maxDate}
                    dateDisplayFormat="dd MMMM yyyy"
                />
            </Popover>
        );
    }

    function selectDate() {
        return (
            <>
                <Typography style={classes.labelInput}>
                    {title}
                </Typography>

                <TextField
                    variant="outlined"
                    onClick={handleClick}
                    fullWidth
                    placeholder={placeholder}
                    inputProps={{ min: 0, readOnly: true, style: { textAlign: 'center' } }}
                    style={classes.inputText}
                    value={date ? format(new Date(date), "dd/MM/yyyy") : ''}
                    {...textFieldProps}
                />
            </>
        )
    }

    return (
        <>
            {selectDate()}
            {popOverSelectDate()}
        </>
    );
}
